import React, { useEffect } from 'react';
import { PayPalButtons, usePayPalScriptReducer } from '@paypal/react-paypal-js';

const CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID || '';

function PayPalSubscriptionCard({
  planId,
  disabled = false,
  priceLabel = '$2.99/month',
  trialDays = 0,
  onApprove,
  onError,
  onCancel,
}) {
  const [{ isPending, isRejected }, dispatch] = usePayPalScriptReducer();

  useEffect(() => {
    if (!CLIENT_ID) {
      return;
    }
    dispatch({
      type: 'resetOptions',
      value: {
        'client-id': CLIENT_ID,
        components: 'buttons',
        currency: 'USD',
        intent: 'subscription',
        vault: true,
      },
    });
  }, [dispatch]);

  if (!CLIENT_ID) {
    return <p className="muted-text">PayPal client configuration is missing.</p>;
  }

  if (!planId) {
    return <p className="muted-text">VixPremium PayPal plan ID is not configured yet.</p>;
  }

  if (isRejected) {
    return <p className="muted-text">PayPal could not load the subscription button.</p>;
  }

  return (
    <div className="paypal-subscription-shell">
      <div className="paypal-subscription-price">
        {trialDays > 0 ? (
          <>
            <strong>{trialDays}-day free trial</strong>
            <span>then {priceLabel} · cancel anytime</span>
          </>
        ) : (
          <>
            <strong>{priceLabel}</strong>
            <span>Cancel anytime</span>
          </>
        )}
      </div>
      {isPending ? <p className="muted-text">Loading PayPal…</p> : null}
      <PayPalButtons
        key={`subscription:${planId}`}
        disabled={disabled}
        forceReRender={[planId, disabled]}
        style={{ layout: 'vertical', color: 'gold', shape: 'pill', label: 'subscribe' }}
        createSubscription={(data, actions) => actions.subscription.create({
          plan_id: planId,
        })}
        onApprove={async (data) => {
          await onApprove?.(data);
        }}
        onError={(error) => {
          onError?.(error);
        }}
        onCancel={(data) => {
          onCancel?.(data);
        }}
      />
    </div>
  );
}

export default PayPalSubscriptionCard;
